// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3QlAP","subheader":"ReorderModal_subheader__2649r","listWrap":"ReorderModal_listWrap__CKfT9"};